function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "add1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 0 75.070312 L 262 75.070312 L 262 336.929688 L 0 336.929688 Z M 0 75.070312 "
})));

function SvgAddIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "23px",
    viewBox: "0 0 262.5 337.500003",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, /*#__PURE__*/React.createElement("g", {
    id: "addicon1"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#add1)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,70.588684%,62.348938%)",
      fillOpacity: 1
    },
    d: "M 237.890625 181.710938 L 155.859375 181.710938 L 155.859375 99.679688 C 155.859375 86.089844 144.84375 75.070312 131.25 75.070312 C 117.65625 75.070312 106.640625 86.089844 106.640625 99.679688 L 106.640625 181.710938 L 24.609375 181.710938 C 11.015625 181.710938 0 192.730469 0 206.320312 C 0 219.914062 11.015625 230.929688 24.609375 230.929688 L 106.640625 230.929688 L 106.640625 312.960938 C 106.640625 326.554688 117.65625 337.570312 131.25 337.570312 C 144.84375 337.570312 155.859375 326.554688 155.859375 312.960938 L 155.859375 230.929688 L 237.890625 230.929688 C 251.484375 230.929688 262.5 219.914062 262.5 206.320312 C 262.5 192.730469 251.484375 181.710938 237.890625 181.710938 Z M 237.890625 181.710938 "
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIcon);
export default __webpack_public_path__ + "static/media/AddIcon.ac6d0a3f.svg";
export { ForwardRef as ReactComponent };